import { z } from 'zod/v3';

export const ALLOWED_COMPANIES = ['CZIF', 'LLC', 'ES'] as const;
export const ALLOWED_INITIATIVES = ['Science', 'Education', 'Central Tech'] as const;

export const CZITagSchema = z.object({
  company: z.enum(ALLOWED_COMPANIES),
  initiative: z.enum(ALLOWED_INITIATIVES),
  team: z.string().min(1),
  project: z.string().min(1),
  'slack:support': z.array(z.string()).min(1),
  'email:support': z.array(z.string()).optional(),
});

export const AwsAccountRequestInputsSchema = z.object({
  accountName: z
    .string()
    .regex(/^[a-z][0-9a-z-]+$/, 'Account name must be lowercase alphanumeric with hyphens'),
  envType: z.enum(['prod', 'nonprod']),
  approverSet: z.object({
    setName: z.string().min(1),
    isNew: z.boolean(),
    owners: z.array(z.string()).optional(),
  }),
  enableEnterpriseSupport: z.boolean(),
  justification: z.string().min(1, 'Justification is required'),
  tags: CZITagSchema,
});

export type AwsAccountRequestInputs = z.infer<typeof AwsAccountRequestInputsSchema>;

export interface InfraRequestTypeConfig {
  schema: z.ZodType;
  label: string;
  enrich?: (inputs: Record<string, any>) => Record<string, any>;
}

export const REQUEST_TYPE_CONFIGS: Record<string, InfraRequestTypeConfig> = {
  'aws-account': {
    schema: AwsAccountRequestInputsSchema,
    label: 'AWS Account',
    enrich: (inputs) => {
      const tags = { ...inputs.tags };
      return { ...inputs, tags };
    },
  },
};

export const REQUEST_TYPE_SCHEMAS: Record<string, z.ZodType> = Object.fromEntries(
  Object.entries(REQUEST_TYPE_CONFIGS).map(([k, v]) => [k, v.schema]),
);

export const REQUEST_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  Object.entries(REQUEST_TYPE_CONFIGS).map(([k, v]) => [k, v.label]),
);
